import {getTodayStartTime} from 'shared/utils/dateTime';

import {useRefreshCore} from 'ui/adapters/Core';
import {useDispatch} from 'ui/store';
import {updateLastRecalc as updateLastRecalcAction} from 'store/LastRecalcDateTime';

export type StateKind = CoreState | StorableState;
export type StateUpdater<TState extends StateKind> = (state: TState) => void;

export function useRefreshStore(): StateUpdater<CoreState> {
  const refreshTime = useDispatch(updateLastRecalcAction);
  const refreshCore = useRefreshCore();

  return function refreshStore(state: CoreState): void {
    refreshTime(getTodayStartTime());
    refreshCore(state);
  };
}
